import { Serializable } from "../core";

export type TransactionResult = "Pending" | "successful" | "failure";

export class Transaction implements Serializable<Transaction> {
  amount!: number;
  result!: TransactionResult;
  discountCode?: string;

  deserialize(json: any): Transaction {
    this.amount = json.amount;
    this.result = json.result as TransactionResult;
    this.discountCode = json.discount_code;
    return this;
  }
}
